import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';
import ParentContentCard from '../common/ParentContentCard';
import { checkCollectionSnapPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import { snippetShapshotText } from '../../common/docs/content';
import showAlert from '../../common/utils/alert';
import { COLLECTION_SNAPSHOT } from 'drapcode-constant';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class ListCollectionSnapshot extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
    actions.loadCollectionSnapshots({ projectId, version });
  }

  handleCollectionSnapshotDelete = (uuid) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const preConfirm = () => {
      actions.deleteCollectionSnapshot({ projectId, version, uuid });
    };
    showAlert('Are you sure, you want to delete it?', preConfirm, 'Yes,delete it! ');
  };
  showSnapshots = () => {
    const { appSetting } = this.props;
    const { projectDetail, permissionFlags, collectionSnapshots } = appSetting;
    if (!projectDetail) {
      return '';
    }
    const { uuid: projectId } = projectDetail;
    const isReadOnly = isProjectReadOnly(projectId);
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    const deleteFlag = permissionsArray.includes(COLLECTION_SNAPSHOT);
    if (!collectionSnapshots.length) {
      return (
        <tr>
          <td className="align-middle"># </td>
          <td className="align-middle"> Collection Snapshots not found!</td>
          <td className="text-right"></td>
        </tr>
      );
    }
    return collectionSnapshots
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .map((collectionSnapshot, index) => (
        <tr key={collectionSnapshot.uuid} className="text-left">
          <td className="align-middle">{index + 1}</td>
          <td className="align-middle">{collectionSnapshot.name}</td>
          <td className="text-right">
            <button
              className="btn btn-xs btn-theme-delete"
              onClick={() =>
                deleteFlag && !isReadOnly
                  ? this.handleCollectionSnapshotDelete(collectionSnapshot.uuid)
                  : undefined
              }
              title={isReadOnly ? 'Read-Only Mode' : `Delete ${collectionSnapshot.name}`}
              style={{
                cursor: deleteFlag && !isReadOnly ? 'pointer' : 'not-allowed',
                opacity: !isReadOnly ? 1 : 0.5,
              }}
              disabled={isReadOnly}
            >
              <i className={`wb ${drapcodeIcon('delete')}`}></i> Delete
              {deleteFlag ? null : (
                <>
                  &nbsp;
                  <TooltipInfo
                    title={description}
                    headerText={`Permission Disabled!`}
                    showHeader={true}
                    showArrow={true}
                  />
                </>
              )}
            </button>
          </td>
        </tr>
      ));
  };

  render() {
    const { appSetting } = this.props;
    const { projectDetail } = appSetting;
    const isAllowed = checkCollectionSnapPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Collection Snapshots" />;
    }
    if (!projectDetail) {
      return '';
    }

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'collectionSnapshot'} projectDetail={projectDetail} />
        <ParentContentCard bgColor="drapcode-violet" icon="collection" title="Collection Snapshots">
          <div className="row mx-auto h-70 table-responsive">
            <table className="table table-bordered table-hover table-sm table-word-break">
              <thead>
                <tr>
                  <th>#</th>
                  <th className="w-90">Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>{this.showSnapshots()}</tbody>
            </table>
          </div>
        </ParentContentCard>
        <ParentDocCard>
          <h5>
            <b>About Snippet Snapshots</b>
          </h5>
          <p>{snippetShapshotText}</p>
          <br />
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/constants-in-collection" />
        </ParentDocCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListCollectionSnapshot);
